import QrScanner from 'qr-scanner'

import { getPhotoDecodeSizes, type ImageSize } from '../_utils/qrCamera'

// qr-scanner 는 File 을 <img> 로 읽어 scanRegion 을 적용한다. EXIF 회전이 붙은 세로 사진에서 createImageBitmap 과
// <img> 의 가로세로가 브라우저마다 다를 수 있어 같은 방식으로 잰다
const readImageSize = async (file: File): Promise<ImageSize | undefined> => {
  const url = URL.createObjectURL(file)
  try {
    const image = new Image()
    image.src = url
    await image.decode()
    return { width: image.naturalWidth, height: image.naturalHeight }
  } catch {
    return undefined
  } finally {
    URL.revokeObjectURL(url)
  }
}

/** 찾지 못하면 null */
export const decodeQrPhoto = async (file: File): Promise<string | null> => {
  const size = await readImageSize(file)
  const attempts = size ? getPhotoDecodeSizes(size) : [undefined]

  for (const downScaled of attempts) {
    try {
      const result = await QrScanner.scanImage(file, {
        returnDetailedScanResult: true,
        scanRegion:
          size && downScaled
            ? {
                x: 0,
                y: 0,
                width: size.width,
                height: size.height,
                downScaledWidth: downScaled.width,
                downScaledHeight: downScaled.height,
              }
            : undefined,
      })
      return result.data
    } catch {
      continue
    }
  }
  return null
}
